<template lang="pug">
	section#unidades
		div.wrapper
			div.texto
				h3 Unidades UniFael
				p
					| São  mais de 600 polos espalhados por todo Brasil, com infra-estrutura
					| completa e equipe treinada para ajudar você a alcançar os seus objetivos.
				router-link(:to="{ name: 'unidades'}").confira Ver Unidades >
</template>

<script>
	export default {
		name: "section-unidades"
	}
</script>

<style lang="stylus" scoped src="./Unidades.styl"></style>
